import { Settings } from "luxon"
import { RouterProvider } from "react-router"
import { router } from "routes/router"

import { DEFAULT_TIME_ZONE } from "@shared/utils/date"

Settings.defaultZone = DEFAULT_TIME_ZONE

function App() {
  return <RouterProvider router={router} />
}

export default App
